import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import Seo from '@components/Seo'
import { useStore } from '@Store/'
import { setHeaderColor, setShowHeaderBackground } from '@Store/'
import { colors } from '@styles/vars/colors.style'
import Hero from '@components/_Standard/Hero'
import ListedContent from '@components/_Standard/ListedContent'
import Content from '@components/_Standard/Content'

const StandardContentPage = ({ data }) => {
  const [, dispatch] = useStore()
  const { seo, slug, title, content, listedContent } = data.contentfulStandardContent

  useEffect(() => {
    setHeaderColor(dispatch, colors.white, colors.charcoal)
    setShowHeaderBackground(dispatch, true);
  }, [dispatch])

  return (
    <>
      <Seo data={seo} slug={slug} />

      <Hero title={title} />
      {!listedContent && 
        (<Content data={content} slug={slug} />)
      }
      {listedContent && 
        (<ListedContent list={listedContent} />)
      }
    </>
  )
}

export default StandardContentPage

export const pageQuery = graphql`
  query StandardContentPage($slug: String!) {
    contentfulStandardContent(slug: { eq: $slug }) {
      title
      seo {
        ...SEO
      }
      slug
      content {
        raw
        references {
          ...References
          ... on ContentfulHubspotForm {
            text {
              raw
            }
            formId
            contentful_id
            backgroundColor
            textColor
            submitText
            successMessage
            hideWhereDidYouHear
            hidePhone
            privacyPolicyCheckText {
              raw
            }
            formBottomInfo {
              raw
            }
            additionalFields {
              title
              sectionTitle
              subTitle
              name
              type
              values
              isRequired
              isTwoColumns
            }
          }
        }
      }
      listedContent {
        textOld {
          textOld
        }
        text {
          raw
        }
      }
    }
  }
`
